export default "__VITE_ASSET__DyaIcu7Q__"